if (!window.Tango)
	window.Tango = {};
const t = window.Tango;

t.Component = class {
	root;
	type;
	props;
	state;

	init() { }
	widgetWillMount(shadowDoc) { }
	widgetDidMount() { }
	widgetContentChanged() { }

	constructor(id, ctrlType, props) {
		this.root = id;
		this.type = ctrlType;
		this.props = props;
		this._computedDefs = {};
		this._computedRefs = {};
	}

	// Define a computed property.
	//
	// Signature 1 — flat computed on ctrl state:
	//   this.defineComputed('Wacc', () => { ... });
	//   Creates a computed ref on the ctrl instance (accessed as this.state.Wacc or this.Wacc).
	//   The fn receives `this` (the ctrl instance) as context.
	//
	// Signature 2 — nested computed on a child object (e.g. array element):
	//   this.defineComputed(st => st.Periods[i], 'Ebitda', (o) => { ... });
	//   targetAccessor: function(state) => target object that owns the field
	//   fieldName: property name on that target object
	//   fn: function(targetObj) => computed value; receives the target object as argument
	//   Creates a reactive effect that writes the result into target[fieldName].
	//   This allows arrayitem DOM bindings to pick up the value automatically.
	defineComputed(nameOrAccessor, fnOrFieldName, fn) {
		if (typeof fnOrFieldName === 'function' && fn === undefined) {
			// Signature 1: defineComputed('name', fn)
			this._computedDefs[nameOrAccessor] = {
				fn: fnOrFieldName
			};
		} else {
			// Signature 2: defineComputed(accessor, 'fieldName', fn)
			if (!this._nestedComputedDefs) this._nestedComputedDefs = [];
			this._nestedComputedDefs.push({
				targetAccessor: nameOrAccessor,
				field: fnOrFieldName,
				fn: fn
			});
		}
	}
};

t.Container = class {
	root;

	prepareParms() { }

	constructor(el) {
		this.root = el;
	}
};

t.Event = class {
	callbacks;

	add(callback) {
		if (!this.callbacks)
			this.callbacks = [callback];
		else
			this.callbacks.push(callback);
	}

	invoke(...parms) {
		if (this.callbacks) {
			for (let i = 0; i < this.callbacks.length; i++) {
				if (this.callbacks[i](...parms) == false)
					return false;
			}
		}
	}

	constructor(callback) {
		this.add(callback);
	}
};

t.HtmlWriter = class {
	Icon(name, tip = null, color = null) {
		const el = document.createElement('i')
		el.classList.add('icon', 'icon-' + name);

		if (tip)
			el.setAttribute('title', tip);
		if (color)
			el.style.color = color;

		const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
		svg.classList.add('svgicon-' + name);

		const use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
		use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '/data/icons/svg#icon-' + name);

		svg.appendChild(use);
		el.appendChild(svg);

		return el;
	}

	ChangeIcon(el, name) {
		el.firstChild.firstChild.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '/data/icons/svg#icon-' + name);
	}
};

t.registerComponent = function (cls, fabric) {
	const ctrltype = cls.name.toLowerCase();
	this.serviceProvider.components[ctrltype] = (id, sp) => {
		const props = fabric ? fabric(sp) : {};
		return new cls(id, ctrltype, props);
	}
};

t.registerContainer = function (cls) {
		const ctrltype = cls.name.toLowerCase();
		this.serviceProvider.containers[ctrltype] = el => {
			return new cls(el);
		}
};

t.postComponentServerEvent = function (e) {
	const target = this.serviceProvider.ajaxUtils.state.ctrl[e.ctrlName][e.eventName];
	if (!target.url) target.url = window.location.pathname;
	if (e.parms) target.parms = e.parms;
	if (e.data) target.data = e.data;
	this.serviceProvider.ajaxUtils.postEventWithApiResponse(target);
};

t.serviceProvider = {
	components: {},
	containers: {},

	commonUtils,
	ajaxUtils,
	domActions
};
